import { render } from "./productWeightSku.vue?vue&type=template&id=fcf45876"
import script from "./productWeightSku.vue?vue&type=script&lang=js"
export * from "./productWeightSku.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/AlbbPublishProduct/components/productWeightSku.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fcf45876"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fcf45876', __exports__)) {
    api.reload('fcf45876', __exports__)
  }
  
  module.hot.accept("./productWeightSku.vue?vue&type=template&id=fcf45876", () => {
    api.rerender('fcf45876', render)
  })

}


export default __exports__